import { render, staticRenderFns } from "./CardholderRegister.vue?vue&type=template&id=9be05ed0"
import script from "./CardholderRegister.vue?vue&type=script&lang=js"
export * from "./CardholderRegister.vue?vue&type=script&lang=js"
import style0 from "./CardholderRegister.vue?vue&type=style&index=0&id=9be05ed0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports